import { atom, selector } from 'recoil';
import { FleetTriggerType } from '../types/fleet';

export const fleetMaintenanceRulesReloadListState = atom<boolean>({
  key: 'app.fleet.maintenanceRules.reload',
  default: false,
});

export const fleetMaintenanceRulesFiltersState = atom<{
  page: number;
  triggerType?: FleetTriggerType;
  maintenanceTypeId?: string;
  search: string;
}>({
  key: 'app.fleet.maintenanceRules.filters',
  default: {
    page: 1,
    triggerType: undefined,
    maintenanceTypeId: undefined,
    search: '',
  },
});

export const fleetMaintenaceRulesHasAnyFilterState = selector<boolean>({
  key: 'app.fleet.maintenanceRules.filters.any',
  get: ({ get }) => {
    const filters = get(fleetMaintenanceRulesFiltersState);
    const hasTriggerTypeFilter = filters.triggerType !== undefined;
    const hasMaintenanceTypeIdFilter = filters.maintenanceTypeId !== undefined;

    return hasTriggerTypeFilter || hasMaintenanceTypeIdFilter;
  },
});
